/* DS free delivery bar v2 (21 Oct 2026). Re-reads /cart.js after every cart change. */
(function () {
  if (customElements.get('ds-free-delivery-bar')) return;
  var fmt = function (p) { return '\u00a3' + (p / 100).toFixed(2); };
  customElements.define('ds-free-delivery-bar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { self.refresh(); }, 150); });
      }
      this._onRefresh = function () { self.refresh(); };
      document.addEventListener('fdb:refresh', this._onRefresh);
      this.refresh();
    }
    disconnectedCallback() {
      if (this.unsub) this.unsub();
      document.removeEventListener('fdb:refresh', this._onRefresh);
    }
    refresh() {
      var self = this;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); })
        .catch(function () {});
    }
    render(cart) {
      var ex = window.DSFDB_EXCLUDED || null;
      if (!ex) return; /* list not loaded, keep the server-rendered state */
      var t = parseInt(this.dataset.threshold, 10), elig = 0, hasEx = false;
      (cart.items || []).forEach(function (i) {
        if (ex.has(String(i.variant_id))) hasEx = true; else elig += i.final_line_price;
      });
      var left = t - elig, state = left <= 0 ? 'free' : 'under';
      if (cart.item_count > 0 && elig === 0 && hasEx) state = 'excluded-only';
      this.classList.remove('dsfdb--free', 'dsfdb--under', 'dsfdb--excluded-only');
      this.classList.add('dsfdb--' + state);
      var msg = this.querySelector('.dsfdb__msg'), note = this.querySelector('.dsfdb__note');
      if (state === 'free') msg.innerHTML = '<span class="dsfdb__tick" aria-hidden="true">&#10003;</span> You\'ve got <strong>free delivery</strong>';
      else if (state === 'excluded-only') msg.textContent = 'Drinks cases and alcohol have their own delivery charge';
      else msg.innerHTML = 'You\'re <strong>' + fmt(left) + '</strong> away from <strong>free delivery</strong>';
      note.innerHTML = hasEx
        ? 'Drinks cases and alcohol don\'t count towards free delivery and are charged separately.'
        : 'Free UK mainland standard delivery on orders over \u00a330. Free click &amp; collect in Tyseley.';
      this.querySelector('.dsfdb__fill').style.width = Math.max(0, Math.min(100, Math.round((elig * 100) / t))) + '%';
    }
  });
})();
